import { IPublishOptionSchema } from '../internalTypes';

export function getOptionId(option: IPublishOptionSchema): string {
  const {
    tariffIdentificator: { tariffId, tariffGridType },
  } = option;

  return `${tariffId}${tariffGridType}`;
}
